import { Component, Input, OnInit, Output, EventEmitter, OnChanges, SimpleChanges, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MultipleFilterProperty } from '../../_model/multiple-filter-property';
import { TableFilters } from '../../_model/table-response/table-filters';
import { DatePipe } from '@angular/common';
import { MatChipsModule } from '@angular/material/chips';
import { Constants } from '../../_model/constants';
import { ExportService } from '../../service/export.service';
import { Subscription } from 'rxjs';
import { ClientStateService } from '../navbar/client-state.service';
import { LoginStateService } from "../../pages/login/login-state.service";
import { SnackbarService } from '../../service/snackbar.service';
import { environment } from '../../../environments/environment';
import { User } from '../../_model/user/user';
import { UserService } from '../../service/user.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { BsDatepickerModule, BsDatepickerConfig } from 'ngx-bootstrap/datepicker';

@Component({
    selector: 'app-multiple-input-filter',
    templateUrl: './multiple-input-filter.component.html',
    standalone: true,
    imports: [
        MatChipsModule,
        MatProgressSpinnerModule,
        MatFormFieldModule,
        MatSelectModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        FormsModule,
        ReactiveFormsModule,
        BsDatepickerModule
    ],
    styleUrls: ['./multiple-input-filter.component.scss']
})
export class MultipleInputFilterComponent implements OnInit, OnChanges, OnDestroy {

    @Input() tableFilters: TableFilters[] = [];
    @Output() selectedFilter = new EventEmitter<FormGroup>();
    @Output() exportLoading = new EventEmitter<boolean>();

    private clientSubscription!: Subscription;

    localTableFilters: TableFilters[] = [];
    filterForms!: FormGroup;
    todayDate: Date | null = null;
    minDate: Date | undefined;
    maxDate: Date | undefined;
    selectedValue: string = 'Date Received';
    bsConfig?: Partial<BsDatepickerConfig>;
    bsRangeValue?: Date[];

    filterArray: Array<MultipleFilterProperty> = [];
    dateFilterSelected = false;
    filterApplied = false;
    removable = true;
    filterAdded = false;
    dateFilterAdded = false;
    excelClicked = false;
    isAddClicked = false;
    searchClicked = false;
    isLoadingResults = false;

    visitFlag = false;
    workOrderFlag = false;

    // Region specific options
    workOrderOptions: string[] = [];
    private readonly workOrdersUS_Asia: string[] = ['CORRECTIVE', 'MAINTENANCE', 'UNDEFINED'];
    private readonly workOrdersUK: string[] = ['JOBS', 'MAINTENANCE', 'CALL OUT', 'FOLLOW-UP', 'RECOMMENDATION', 'NO-ACTION', 'FIELD BIOLOGIST'];

    constructor(
        private fb: FormBuilder,
        public datepipe: DatePipe,
        private exportService: ExportService,
        private userService: UserService,
        private clientStateService: ClientStateService,
        private loginStateService: LoginStateService,
        private sbService: SnackbarService,
        private cdr: ChangeDetectorRef
    ) {
        this.initializeFilter();
    }

    ngOnChanges(changes: SimpleChanges) {
    if (changes['tableFilters']) {
      this.localTableFilters = this.tableFilters;
      this.cdr.detectChanges();
     }
    }

    ngOnInit() {
        this.setDateLimits(false);
        this.applyTheme();
        this.setRegionSpecifics();
        //this.localTableFilters = this.tableFilters || [];

        this.clientSubscription = this.clientStateService.clientStateChanged$.subscribe(() => {
            this.resetState();
        });

        this.handleLoginStateFlags();
    }

    ngOnDestroy(): void {
        if (this.clientSubscription) {
            this.clientSubscription.unsubscribe();
        }
    }

    applyTheme() {
        this.bsConfig = Object.assign({}, { containerClass: 'theme-blue', displayMonths: 1 });
    }

    private setRegionSpecifics() {
        if (environment.region === 'EUROPE') {
            this.workOrderOptions = this.workOrdersUK;
        } else {
            this.workOrderOptions = this.workOrdersUS_Asia;
        }
    }

    private handleLoginStateFlags() {
        if (this.loginStateService.isVisits) {
            this.visitFlag = true;
            this.loginStateService.isVisits = false;
        } else if (this.loginStateService.isWorkOrders) {
            this.workOrderFlag = true;
            this.loginStateService.isWorkOrders = false;
        } else {
            this.visitFlag = false;
            this.workOrderFlag = false;
            this.removeItem();
        }
    }

    private resetState() {
        this.initializeFilter();
        this.filterApplied = false;
        this.dateFilterSelected = false;
        this.filterAdded = false;
        this.dateFilterAdded = false;
        this.visitFlag = false;
        this.workOrderFlag = false;
        this.filterArray = [];
        this.bsRangeValue = undefined;
        this.setDateLimits(false);
    }

    removeItem() {
        if (this.visitFlag) {
            this.loginStateService.isVisits = false;
            this.visitFlag = false;
        } else if (this.workOrderFlag) {
            this.loginStateService.isWorkOrders = false;
            this.workOrderFlag = false;
        }
    }

    checkAndCallMethods() {
    // Intercept and validate the Visit ID before proceeding to add, search, or export
    if (this.filterForms.value.tableFilter && this.filterForms.value.tableFilter.displayName === Constants.dispalyNameVisitId && this.filterForms.value.value) {
      const cleanValue = String(this.filterForms.value.value).trim();
      this.filterForms.get('value')?.setValue(cleanValue);
      this.filterForms.value.value = cleanValue;

      if (!this.isValidVisitId(cleanValue)) {
        alert(Constants.visitIdErrorAlert);
        return;
      }
    }

    // Intercept and validate FM Store ID (requires a Date filter to be present)
    // const hasDate = this.dateFilterAdded || (this.filterForms.value.tableFilter && this.filterForms.value.tableFilter.displayName === Constants.date && this.filterForms.value.valuedate);

    // if (this.isAddCliecked && this.filterForms.value.tableFilter && this.filterForms.value.tableFilter.displayName === Constants.fmStoreId) {
    //   if (!hasDate) {
    //     alert('FM Store ID filter cannot be used alone. Please add a Date filter first.');
    //     return;
    //   }
    // }

    // if (this.searchClicked || this.excelClicked) {
    //   const hasStoreId = this.filterArray.some(item => item.dispalyName === Constants.fmStoreId) || 
    //                    (this.filterForms.value.tableFilter && this.filterForms.value.tableFilter.displayName === Constants.fmStoreId && this.filterForms.value.value);
      
    //   if (hasStoreId && !hasDate) {
    //     alert('FM Store ID filter cannot be used alone. Please add a Date filter.');
    //     return;
    //   }
    // }

        if (this.isAddClicked) {
            this.addFilter();
        } else if (this.searchClicked) {
            this.emitFilter();
        } else if (this.excelClicked) {
            this.exportToExcel();
        }
    }

    private emitFilter() {
        if (this.filterArray.length > 0) {
            this.filterForms.get('multipleFilterarray')?.setValue(this.filterArray);
        }
        this.selectedFilter.emit(this.filterForms);
    }

    private exportToExcel() {
        if (this.filterArray.length > 0) {
            this.filterForms.get('multipleFilterarray')?.setValue(this.filterArray);
        }
        this.getDatatoExcel(this.filterForms);
    }

    isValidVisitId(visitId: string): boolean {
    if (!visitId) {
      return false;
    }
    
    // Convert to string and trim any leading/trailing spaces from copy-pasting
    const cleanVisitId = String(visitId).trim();

    // Allow only alphanumeric characters and hyphens
    const regex = /^[a-zA-Z0-9-]+$/;
    return regex.test(cleanVisitId);
   }

    addFilter() {
        const formValue = this.filterForms.value;
        const displayName = formValue.tableFilter.displayName;
        const value = formValue.value;

        // Check for duplicates
        const isDuplicate = this.filterArray.some(item => item.value === value);
        const existItem = this.filterArray.filter(item => item.dispalyName === displayName);
        if (this.filterForms.value.tableFilter.displayName === Constants.dispalyNameVisitId) {

            // Clean the input value so the trimmed ID is sent to the backend
            this.filterForms.value.value = String(this.filterForms.value.value).trim();

            if (!this.isValidVisitId(this.filterForms.value.value)) {
                //alert('You can only filter by one Visit ID at a time. Only alphanumeric characters and hyphens (-) are allowed.');
                return;
            }
        }

        if (isDuplicate || (existItem.length > 0 && displayName !== Constants.status)) {
            alert(Constants.duplicateFilterAlert);
            return;
        }

        let multipleFilterProperty = new MultipleFilterProperty();
        multipleFilterProperty.dispalyName = displayName;
        multipleFilterProperty.column = formValue.tableFilter.column;

        if (displayName === Constants.date) {
            const existDateItem = this.filterArray.some(item => item.dateValue === displayName);
            if (existDateItem) {
                alert(Constants.dateErrorAlert);
                return;
            }

            multipleFilterProperty.dateValue = displayName;
            multipleFilterProperty.dateBackendName = value;
            if (this.bsRangeValue && this.bsRangeValue.length === 2) {
                multipleFilterProperty.origionalStartDateFormat = this.bsRangeValue[0];
                multipleFilterProperty.origionalEndDateFormat = this.bsRangeValue[1];
            } else {
                return;
            }

            const dateFormat = (environment.locale === "en-GB") ? Constants.dateFormatEngb : Constants.dateFormaten029;
            const start_date = this.datepipe.transform(multipleFilterProperty.origionalStartDateFormat, dateFormat);
            const end_date = this.datepipe.transform(multipleFilterProperty.origionalEndDateFormat, dateFormat);

            multipleFilterProperty.value = `${start_date} - ${end_date}`;
            this.dateFilterAdded = true;
        } else {
            multipleFilterProperty.value = value;
        }

        this.filterArray.push(multipleFilterProperty);
        this.filterApplied = true;
        this.initializeFilter();
        this.dateFilterSelected = false;
        this.filterAdded = true;
    }


    changeValue(filter: any) {
        const filterName = filter?.displayName || '';
        const isScheduled = filterName === Constants.scheduledStartDate || filterName.toLowerCase().includes('scheduled');
        if (isScheduled) {
            this.setDateLimits(true);
            this.dateFilterSelected = true;
            this.bsRangeValue = undefined;
            this.cdr.detectChanges();
        } else {
            this.dateFilterSelected = false;
            this.setDateLimits(false);
            this.bsRangeValue = undefined;
        }
    }

    onValueSelected(value: string) {
        this.filterForms.get('value')?.setValue(value);
        const valStr = typeof value === 'string' ? value : '';
        const isScheduled = valStr === Constants.scheduledStartDate || valStr.toLowerCase().includes('scheduled');

        this.setDateLimits(isScheduled);
        this.dateFilterSelected = false;
        this.cdr.detectChanges();
        this.dateFilterSelected = true;
        this.bsRangeValue = undefined;
        this.cdr.detectChanges();
    }

    setDateLimits(isScheduled: boolean) {
        if (isScheduled) {
            this.minDate = new Date(Constants.scheduledStartActiveDate);
            this.maxDate = undefined;
            this.todayDate = this.minDate;
        } else {
            this.minDate = undefined;
            this.maxDate = new Date();
            this.todayDate = null;
        }
    }

    private initializeFilter() {
        this.filterForms = this.fb.group({
            tableFilter: '',
            value: '',
            valuedate: this.fb.group({
                start: [''],
                end: ['']
            }),
            multipleFilterarray: []
        });
    }

    compareFilters(f1: any, f2: any): boolean {
        return f1 && f2 ? f1.displayName === f2.displayName : f1 === f2;
    }

    remove(value: string): void {
        const index = this.filterArray.findIndex(e => e.value === value);
        if (index >= 0) {
            this.filterArray.splice(index, 1);
        }

        const dateIndex = this.filterArray.findIndex(e => e.dateValue === Constants.date);
        if (dateIndex === -1) {
            this.dateFilterAdded = false;
            this.bsRangeValue = undefined;
        }

        if (this.filterArray.length == 0) {
            this.filterAdded = false;
            this.selectedFilter.emit(this.filterForms);
        }
    }

    // Helper properties for Template
    get currentDisplayName(): string {
        return this.filterForms.value.tableFilter?.displayName || '';
    }

    get isScheduledDate(): boolean {
        const filterName = (this.filterForms?.value?.tableFilter?.displayName || '').toLowerCase();
        const valueName = (typeof this.filterForms?.value?.value === 'string' ? this.filterForms.value.value : '').toLowerCase();
        return filterName.includes('scheduled') || valueName.includes('scheduled');
    }

    get isArrayType(): boolean {
        return this.filterForms.value.tableFilter?.values?.length > 0;
    }

    get isWorkOrderType(): boolean {
        return this.currentDisplayName === 'Work Order Type';
    }

    get isSingleDateValue(): boolean {
        return this.currentDisplayName === 'Date' && this.filterForms.value.tableFilter?.values?.length === 1;
    }

    isFilterSet(): boolean {
        const displayName = this.currentDisplayName;
        const value = this.filterForms.value.value;

        // Disable if no value
        if (!value) return true;

        // Disable Add button if it is a direct search field (WO Number, etc)
        if ([Constants.dispalyNameWoNumber, Constants.displayNameWoId, Constants.dispalyNameVisitId, Constants.displayNameServiceCoverRef].includes(displayName)) {
            return true;
        }

        if (this.dateFilterSelected) {
            return !this.bsRangeValue || this.bsRangeValue.length !== 2;
        }

        return false;
    }

    isWONumberFilterApplied(): boolean {
        const displayName = this.currentDisplayName;
        const value = this.filterForms.value.value;

        if ([Constants.dispalyNameWoNumber, Constants.displayNameWoId, Constants.dispalyNameVisitId, Constants.displayNameServiceCoverRef].includes(displayName) && value) {
            return true;
        }
        return this.dateFilterAdded;
    }

    isAnyFilterSet(): boolean {
        if (this.filterForms.value.tableFilter && this.filterForms.value.value) {
            return true;
        }
        return this.dateFilterAdded || this.filterArray.length >= 1 || this.visitFlag || this.workOrderFlag;
    }

    isExcelClicked() {
        this.excelClicked = true;
        this.searchClicked = false;
        this.isAddClicked = false;
    }

    isSearchClicked() {
        this.searchClicked = true;
        this.excelClicked = false;
        this.isAddClicked = false;
    }

    isAddFilterClicked() {
        this.isAddClicked = true;
    }

    reset() {
        this.resetState();
        this.selectedFilter.emit(this.filterForms);
        this.removeItem();
    }

    private getDatatoExcel(formValues: FormGroup) {
        this.isLoadingResults = true;
        this.exportLoading.emit(true);
        const user: User = this.userService.getUser();

        this.exportService.getDataToExcel(formValues, user.brand).subscribe({
            next: (response) => {
                this.isLoadingResults = false;
                this.exportLoading.emit(false);
                if (response.data !== null) {
                    window.open(response.data, "_blank");
                } else {
                    this.sbService.openSnackBar(response.message, 'Close');
                }
            },
            error: (error) => {
                this.isLoadingResults = false;
                this.exportLoading.emit(false);
                this.sbService.openSnackBar(error, 'Close');
            }
        });
    }
}
